import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/account");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs font-mono uppercase tracking-[0.3em] text-slate-500">{t("auth.getStarted")}</div>
      <h1 className="mt-2 font-display font-extrabold text-4xl tracking-tight">{t("auth.createAccount")}</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-4">
        <div>
          <label className="text-xs font-mono uppercase tracking-widest">{t("auth.fullName")}</label>
          <input
            data-testid="register-name"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="mt-1 w-full h-11 px-3 border border-black/15 focus:border-electric focus:outline-none"
          />
        </div>
        <div>
          <label className="text-xs font-mono uppercase tracking-widest">{t("auth.email")}</label>
          <input
            data-testid="register-email"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-1 w-full h-11 px-3 border border-black/15 focus:border-electric focus:outline-none"
          />
        </div>
        <div>
          <label className="text-xs font-mono uppercase tracking-widest">{t("auth.phone")}</label>
          <input
            data-testid="register-phone"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            className="mt-1 w-full h-11 px-3 border border-black/15 focus:border-electric focus:outline-none"
          />
        </div>
        <div>
          <label className="text-xs font-mono uppercase tracking-widest">{t("auth.passwordHint")}</label>
          <input
            data-testid="register-password"
            type="password"
            required
            minLength={6}
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="mt-1 w-full h-11 px-3 border border-black/15 focus:border-electric focus:outline-none"
          />
        </div>
        {error && <div data-testid="register-error" className="text-sm font-mono text-destructive">{error}</div>}
        <button
          type="submit"
          disabled={loading}
          data-testid="register-submit"
          className="w-full h-12 bg-ink text-white hover:bg-electric disabled:opacity-50 transition-colors text-xs font-mono uppercase tracking-[0.2em]"
        >
          {loading ? t("auth.creating") : t("auth.createBtn")}
        </button>
      </form>
      <div className="mt-6 text-sm">
        {t("auth.haveAccount")}{" "}
        <Link to="/login" className="text-electric underline">
          {t("auth.signIn")}
        </Link>
      </div>
    </div>
  );
}
